import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { isAuthenticated } from "../functions/isAuthenticated";

const GuestLayout = () => {
  const { auth } = useAuth();

  if (isAuthenticated(auth)) return <Navigate to="/" replace />
  
  return <Outlet />
}

export default GuestLayout